import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/ui/Button/Button';
import { UserSettings } from '../../components/UserSettings/UserSettings';
// import ColorThemeSettings from '../../components/Settings/ColorThemeSettings';

export const SettingsPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBackToDashboard = () => {
    navigate('/');
  };

  return (
    <div className="settings-workspace">
      <div className="app-main__container">
        <UserSettings />
        {/* <ColorThemeSettings /> */}
      </div>
      <Button
        variant="primary"
        onClick={handleBackToDashboard}
        className="back-to-dashboard"
      >
        {t('settings.backToDashboard')}
      </Button>
    </div>
  );
};